import script from "./WalletExportModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./WalletExportModal.vue?vue&type=script&setup=true&lang=ts"

import "./WalletExportModal.vue?vue&type=style&index=0&id=52440bcb&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52440bcb"]])

export default __exports__